import clsx from "clsx";
import { Link } from "wouter";

export const Tabs = ({ children }) => {
  return (
    <div className="border-b border-stone-700/50 dark:border-white/10">
      <nav aria-label="Tabs" className="-mb-px flex justify-center">
        {children}
      </nav>
    </div>
  );
};

type TabProps =
  | {
      children: React.ReactNode;
      disabled?: boolean;
      selected: boolean;
      href: string;
    }
  | {
      children: React.ReactNode;
      disabled?: boolean;
      selected: boolean;
      onClick: () => void;
    };

export const Tab = (props: TabProps) => {
  const { children, disabled, selected } = props;
  const className = clsx(
    selected
      ? "border-blue-700 dark:border-blue-300 text-blue-700 dark:text-blue-300"
      : "border-transparent text-stone-700 dark:text-white hover:border-stone-400 hover:text-stone-400 dark:hover:border-stone-300 dark:hover:text-stone-300",
    "whitespace-nowrap border-b-2 px-4 py-2 text-sm font-medium cursor-pointer",
    disabled && "opacity-[0.5]",
  );
  if (disabled) {
    return <span className={className}>{children}</span>;
  }
  return "href" in props ? (
    <Link href={props.href} className={className}>
      {children}
    </Link>
  ) : (
    <button onClick={props.onClick} className={className}>
      {children}
    </button>
  );
};

export const PillTabs = ({ children }) => {
  return (
    <nav aria-label="Tabs" className="flex justify-center space-x-4 my-2">
      {children}
    </nav>
  );
};

export const PillTab = ({
  children,
  selected,
  onClick,
}: {
  children: React.ReactNode;
  selected: boolean;
  onClick: () => void;
}) => {
  return (
    <button
      onClick={onClick}
      className={clsx(
        selected
          ? "bg-stone-400 dark:bg-stone-700"
          : "hover:text-stone-500 dark:hover:text-stone-300",
        "rounded-md px-3 py-2 text-sm font-medium cursor-pointer",
      )}
    >
      {children}
    </button>
  );
};
